import { apiCall } from '../helper/Common';

// Client API service using optimized apiCall function
// All backend APIs return: { success: boolean, message: string, data: any }
export const clientAPI = {
  /**
   * Update onboarding status for a client
   * POST /api/onboarding
   * Body: { client_id: number, is_on_boarding: '0'|'1'|'2'|'3' }
   * Returns: { success: true, message: string, data: object }
   */
  async updateOnboardingStatus(clientId, onboardingStatus) {
    try {
      const response = await apiCall('onboarding', 'POST', {
        client_id: clientId,
        is_on_boarding: String(onboardingStatus)
      });
      
      // Backend returns { success, message, data }
      if (response.success) {
        return response;
      }
      throw new Error(response.message || 'Failed to update onboarding status');
    } catch (error) {
      console.error('Error in updateOnboardingStatus:', error);
      throw error;
    }
  }
};

